import { gql } from '@apollo/client'

import { DICTIONARY_WORDS_FRAGMENT } from '../fragments'

const CREATE_DICTIONARY_WORDS_FOR_TYPE_MUTATION = gql`
  mutation createDictionaryWordsForType(
    $data: [DictionaryWordInput!]!
    $type: DictionaryWordType!
    $pageSize: Int
  ) {
    createDictionaryWordsForType(
      data: $data
      type: $type
      pageSize: $pageSize
    ) {
      ...DictionaryWordsFragment
    }
  }
  ${DICTIONARY_WORDS_FRAGMENT}
`

export default CREATE_DICTIONARY_WORDS_FOR_TYPE_MUTATION
